import script from "./danh-sach-nhom-socket.vue?vue&type=script&setup=true&lang=js"
export * from "./danh-sach-nhom-socket.vue?vue&type=script&setup=true&lang=js"

import "./danh-sach-nhom-socket.vue?vue&type=style&index=0&id=a49cd5c4&scoped=true&lang=css"
import "./danh-sach-nhom-socket.vue?vue&type=style&index=1&id=a49cd5c4&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a49cd5c4"]])

export default __exports__